var Backbone = require('backbone');
var _ = require('underscore');

var SubSection = require('front/pages/Section/SubSection');

var IndexHero = require('front/components/IndexHero/IndexHero');
var IndexDescription = require('front/components/IndexDescription/IndexDescription');
var Discount = require('front/components/Discount/Discount');
var IndexFeatures = require('front/components/IndexFeatures/IndexFeatures');
var IndexPartners = require('front/components/IndexPartners/IndexPartners');
var IndexSlider = require('front/components/IndexSlider/IndexSlider');
var IndexFinders = require('front/components/IndexFinders/IndexFinders');
var Objects = require('front/components/Objects/Objects');

require('./IndexPopup.less');

module.exports = SubSection.extend({
    template: require('./IndexPopup.jinja'),

    el: '.IndexPopup',

    apiUrl: 'api/index',

    initialize: function (options) {
        SubSection.prototype.initialize.call(this, options);
    },

    viewsRegistration: function () {
        this.registerView('hero', new IndexHero());
        this.registerView('descripiton', new IndexDescription());
        this.registerView('discount', new Discount());
        this.registerView('features', new IndexFeatures());
        this.registerView('partners', new IndexPartners());
        this.registerView('slider', new IndexSlider());
        this.registerView('finders', new IndexFinders());
        this.registerView('objects', new Objects({
            el: this.$('.Objects'),
            short: true
        }));
    },

    render: function () {
        SubSection.prototype.render.call(this);

        app.els.$body.addClass('Index');
    },

    deactivate: function (params) {
        app.els.$body.removeClass('Index');

        return SubSection.prototype.deactivate.call(this, params);
    },

    playIn: function () {
        this.$el.hide();
        // $(window).scrollTop(0);

        return new Promise(function (resolve) {
            this.$el.fadeIn(function () {
                resolve();
            });
        }.bind(this));
    },

    playOut: function () {
        return new Promise(function (resolve) {
            this.$el.fadeOut(function () {
                // app.els.$body.removeClass('u-noScroll');
                resolve();
            });
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/IndexPopup.js
// module id = 57
// module chunks = 0